import { AppStore } from '../../../shared/store/lookup-store.service';
import { Component, OnInit } from '@angular/core';
import { JobsStore } from '../../../jobs/store/jobs-store.service';
import { JobFilter } from '../../../jobs/models/job-filter';
import { Router } from '@angular/router';
import { UiStateStore } from '../../../shared/store/ui-state-store.service';
import { Subscription } from 'rxjs';
import { AuthenticationResult } from '../../../shared/models/authentication-result';
import { environment } from '../../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  active = 1;
  user: AuthenticationResult = null;
  subscriptions: Subscription[] = [];
  safeVideoUrl: SafeResourceUrl;
  constructor(public lookupStore: AppStore,
    private router: Router,
    private jobStore: JobsStore,
    private uiStore: UiStateStore,
    public sanitizer: DomSanitizer) { 
      this.safeVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${environment.baseUrl}/resources/video/Manzoul-video.mp4`);
    }

  ngOnInit() {
    this.subscriptions.push(
      this.uiStore.authenticatedUser.subscribe(user => {
        if (!user) {
          return;
        }

        this.user = user;
      }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  onTrendingKeywordClicked(trendingKeyword: string): void {
    let jobFilter = new JobFilter();
    jobFilter.keyword = trendingKeyword;

    this.jobStore.loadSearchResults(jobFilter);
    this.router.navigate(['/search-jobs']);
  }

  onPostJobClicked(): void {
    if (this.user) {
      this.router.navigate(['/employer/post-job']);
    } else {
      this.router.navigate(['/signin']);
    }
  }
}
